// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
export const otaNet = {
  title: "What you receive",
  gross: "Reservation total",
  grossOnChannel: "Reservation total on {channel}",
  grossOfUnit: "{unit} total",
  commission: "{channel} commission and charges ({rate}%)",
  commissionOfBase: "{channel} commission and charges ({rate}% of {base})",
  commissionReal: "{channel} commission (reported by the channel)",
  vat: "VAT on the commission ({vat}%)",
  net: "You receive (approx.)",
  howItWorks: "How it's calculated",
  infoEstimate: "Estimate based on the percentages in this property's “OTA commissions”. The OTA may transfer a slightly different amount (rounding, promotions, payment charges).",
  infoBase: "The tourist tax and the security deposit don't pay commission.",
  infoReal: "{channel} reported the commission for this reservation. The VAT on the commission is an estimate using the percentage in “OTA commissions”, so what you receive is still approximate.",
  infoRealNoVat: "{channel} reported the commission for this reservation. Even so, the transfer may vary slightly (rounding, payment charges).",
  airbnbNet: "Airbnb already pays out the net amount: what you see is what you receive.",
  apart: "Doesn't include {amount} you charge separately: that doesn't go through {channel}.",
  theChannel: "the OTA",
};
